import React from 'react';
import propTypes from 'prop-types';
export const HijriIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512.001 512.001"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <path
            d="M509.627,81.138c-1.973-6.073-7.222-10.499-13.542-11.416l-57.415-8.343L412.994,9.351C410.169,3.624,404.337,0,397.952,0
       c-6.385,0-12.217,3.625-15.043,9.35l-25.677,52.028l-57.415,8.343c-6.318,0.917-11.569,5.343-13.542,11.416
       c-1.974,6.074-0.328,12.74,4.244,17.196l41.546,40.499l-9.808,57.183c-1.079,6.294,1.507,12.654,6.673,16.408
       c5.164,3.751,12.012,4.249,17.666,1.277l51.354-27l51.355,27c5.649,2.969,12.5,2.477,17.666-1.278
       c5.166-3.752,7.753-10.113,6.673-16.407l-9.808-57.183l41.546-40.498C509.955,93.878,511.601,87.212,509.627,81.138z
        M434.105,120.964c-3.953,3.854-5.757,9.406-4.824,14.848l5.552,32.374L405.758,152.9c-2.444-1.284-5.125-1.927-7.806-1.927
       c-2.681,0-5.362,0.642-7.806,1.927l-29.075,15.286l5.552-32.374c0.933-5.442-0.871-10.994-4.824-14.848l-23.522-22.929
       l32.508-4.724c5.464-0.794,10.187-4.225,12.63-9.176l14.537-29.457l14.538,29.457c2.444,4.951,7.167,8.382,12.63,9.176
       l32.506,4.724L434.105,120.964z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M500.361,299.326c-6.315-3.812-14.383-3.051-19.874,1.879c-36.233,32.524-81.655,48.663-126.99,48.658
       c-48.689-0.003-97.275-18.623-134.208-55.556c-71.321-71.321-74.351-186.054-6.897-261.2c4.928-5.49,5.691-13.556,1.879-19.874
       c-3.813-6.317-11.307-9.398-18.46-7.599c-45.132,11.371-86.233,34.627-118.861,67.255c-100.524,100.524-100.533,263.225,0,363.758
       c100.411,100.412,263.224,100.532,363.757,0c32.626-32.627,55.883-73.729,67.253-118.86
       C509.761,310.631,506.678,303.138,500.361,299.326z M416.983,412.923c-87.207,87.206-229.103,87.206-316.311,0
       c-87.412-87.413-87.42-228.891,0-316.312c16.148-16.146,34.693-29.655,54.922-40.118
       c-44.315,84.658-30.479,191.086,39.971,261.535C266.014,388.478,372.441,402.312,457.1,358
       C446.636,378.23,433.129,396.776,416.983,412.923z"
          />
        </g>
      </g>
    </svg>
  );
};
HijriIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
HijriIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
